import React, { useState } from 'react';
import { Plus, ListChecks, Edit2, Trash2, GripVertical, CheckCircle2 } from 'lucide-react';
import { DEFAULT_SALES_RUBRIC } from '@/lib/defaultRubric';

export default function RubricBuilder() {
    const [rubrics, setRubrics] = useState(DEFAULT_SALES_RUBRIC);

    return (
        <div className="animate-fade-in max-w-4xl">
            <div className="flex items-center justify-between mb-8">
                <div>
                    <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-1">Rubrics & Scorecards</h2>
                    <p className="text-sm text-[var(--text-tertiary)]">Design AI audit evaluation rubrics, define compliance signals, and set auto-fail conditions.</p>
                </div>
                <button className="flex items-center gap-2 px-4 py-2 bg-[var(--primary)] text-white text-sm font-medium rounded-lg hover:bg-[var(--primary-hover)] transition-colors">
                    <Plus size={16} />
                    New Category
                </button>
            </div>

            <div className="space-y-6">
                {rubrics.map((category, idx) => (
                    <div key={idx} className="bg-[var(--bg-surface)] border border-[var(--border)] rounded-xl overflow-hidden shadow-sm">
                        <div className="flex items-center justify-between p-4 border-b border-[var(--border)] bg-[var(--bg-subtle)]/50">
                            <div className="flex items-center gap-3">
                                <GripVertical size={16} className="text-[var(--text-tertiary)] cursor-grab" />
                                <h3 className="text-sm font-semibold text-[var(--text-primary)]">{category.category}</h3>
                                <span className="px-2 py-0.5 rounded-full bg-[var(--bg-muted)] text-[10px] font-medium text-[var(--text-secondary)]">
                                    {category.items.length} Parameters
                                </span>
                            </div>
                            <div className="flex items-center gap-2">
                                <button className="p-1.5 text-[var(--text-tertiary)] hover:text-[var(--text-primary)] rounded-md hover:bg-[var(--bg-muted)] transition-colors">
                                    <Edit2 size={14} />
                                </button>
                                <button className="p-1.5 text-[var(--text-tertiary)] hover:text-red-600 rounded-md hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors">
                                    <Trash2 size={14} />
                                </button>
                            </div>
                        </div>

                        <div className="divide-y divide-[var(--border)]">
                            {category.items.map((item) => (
                                <div key={item.id} className="p-4 hover:bg-[var(--bg-hover)] transition-colors flex items-start gap-4 group">
                                    <ListChecks size={18} className="text-[var(--text-tertiary)] mt-0.5" />
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center justify-between mb-2">
                                            <h4 className="text-sm font-medium text-[var(--text-primary)]">{item.label}</h4>
                                            <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                                <button className="text-[11px] font-medium text-[var(--primary)] hover:underline">Edit</button>
                                            </div>
                                        </div>
                                        <div className="space-y-2">
                                            {item.signals.map((signal, sIdx) => (
                                                <div key={sIdx} className="flex items-start gap-2">
                                                    <CheckCircle2 size={13} className="text-[var(--primary)] mt-0.5 flex-shrink-0" />
                                                    <span className="text-xs text-[var(--text-secondary)]">{signal}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        
                        <div className="p-3 border-t border-[var(--border)] bg-[var(--bg-subtle)]/30 flex justify-center">
                            <button className="flex items-center gap-1.5 text-xs font-medium text-[var(--text-secondary)] hover:text-[var(--primary)] transition-colors">
                                <Plus size={14} />
                                Add Parameter
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
